<template>
  <div class="wrap">
      <div class="emptyBox colAc" v-if="list.length == 0">
            <img src="../../assets/static/emptyList.png" alt="">
            <div>暂时还没有学员哦</div>
        </div>
      <div v-else class="list rowJbAc">
          <div class="itemBox" v-for="(item,index) in list" :key="index">
              <div class="rowAc firstLine">
                  <div class="name textOver">{{item.studentName}}</div>
                  <div>
                      <img class="sexIco" v-if="item.sex==1" src="../../assets/static/man.svg" />
                      <img class="sexIco" v-else src="../../assets/static/woman.svg" />
                  </div>
              </div>
              <div class="itemLine">{{item.age}}岁</div>
              <div class="rowAc">
                  <div class="phone">{{changePhone(item.phone)}}</div>
                  <div>({{item.parentRelation}})</div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import { getActivityStuAPI } from "../../utils/api/api";
export default {
  data() {
    return {
        list:[
            // {
            //     name:'小红',
            //     sex:0,
            //     age:'12岁',
            //     phone:'13870989787',
            //     relation:'妈妈'
            // },
            // {
            //     name:'小红',
            //     sex:0,
            //     age:'12岁',
            //     phone:'13870989787',
            //     relation:'妈妈'
            // },
            // {
            //     name:'小红',
            //     sex:0,
            //     age:'12岁',
            //     phone:'13870989787',
            //     relation:'妈妈'
            // },
        ],
        activitiesId:'',//活动id
    };
  },
  created() {
  },
  mounted() {
      this.activitiesId = this.$route.params.activitiesId
      this.getList()

  },
  methods: {
      changePhone(phone) {
            var str = ''
            if(phone) {

                str += phone.substring(0,3)
                str += '****'
                str += phone.substring(7,11)
            }
            return str
        },
        getList(){
            var obj = {
                activitiesId:this.activitiesId
            }
             getActivityStuAPI(obj)
            .then((res) => {
                console.log(res.data);
                if (res.resultCode == 200) {
                this.list = res.data ? res.data: [];
                console.log("活动学员获取成功",res.data);
                }
            })
            .catch((err) => {
                console.log(err);
            });
        }
  },
};
</script>
<style lang="scss" scoped>
.wrap{
    height: 100%;
    background: #F4FAFF;
    font-size: 0.14rem;
    overflow: auto;
    padding: 0 0.16rem;
}
.list{
    flex-wrap: wrap;
}
.itemBox{
    width: 1.63rem;
    height: 0.95rem;
    background: #FFFFFF;
    box-sizing: border-box;
    box-shadow: 4px 4px 11px 0px rgba(229,236,243,0.8), -9px -9px 22px 0px rgba(229,236,243,0.1);
    border-radius: 0.1rem;
    margin-top: 20px;
    padding: 0.12rem 0 0 0.12rem;
    font-size: 0.14rem;
    color: #333843;
    line-height: 0.21rem;
    .name{    
    font-weight: 500;
    margin-right:0.04rem;
    }
    .sexIco{
        width: 0.14rem;
        height: 0.14rem;
    }
    .firstLine{
        margin-bottom: 0.07rem;
    }
    .itemLine{
        margin-bottom: 0.05rem;
    }
    .phone{
        margin-right: 0.12rem;
    }
}
.emptyBox {
    img {
        width: 165px;
        height: 114px;
        margin-top: 40px;
    }
    >div {
        font-size: 13px;
        color: #9EA8BA;
        line-height: 19px;
    }
}
</style>
